import { isFullPageScrollEnabled } from '@makemydeal/dr-sales-checkin-store';
import type { IAdditionalSelectors } from '@makemydeal/dr-sales-checkin-types';

export const additionalSelectors: IAdditionalSelectors = {
    isFullPageScrollEnabled: (state: any) => isFullPageScrollEnabled(state)
};
